import { set } from "radashi";
import { BatchSelectionState } from "../batchSelectionSlice";
import { matchesRequest } from "./matchesRequest";

export function markErrored(state: BatchSelectionState, correlationId: string) {
  state.data = state.data.map((row) =>
    matchesRequest(row, correlationId)
      ? set(row, "output", {
          correlationId,
          pipeResult: null,
          status: "error",
          suggestion: null,
        })
      : row,
  );
}
